import { render, staticRenderFns } from "./SitemapCategory.vue?vue&type=template&id=b0853800&"
import script from "./SitemapCategory.vue?vue&type=script&lang=ts&"
export * from "./SitemapCategory.vue?vue&type=script&lang=ts&"
import style0 from "./SitemapCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports